import { interOutnetConfig } from "../../utils/appointment.url.js";
import Header from '@/components/layout/header';
import GxuiHeader from '@/components/layout/gxui-header';
import store from './store.js'
export default {
  name: 'app',
  components: { Header, GxuiHeader },
  data() {
    return {
      showGxFlag: false, //广西头尾部是否展示标识,默认不展示
      headerShow: false,
      isSlhAndWza: false,
    }
  },
  methods: {
    getConfig() {
      interOutnetConfig({
            key: "APPLY_AREA;AGING_KEY;ORDER_TEL_KEY;FIT_FOR_AGE_APP"
          },
          "get"
        )
        .then(res => {
          if (+res.status === 200) {
            this.headerShow = true;
            res.data.map(v => {
              if (v.key == 'APPLY_AREA' && v.value == 'GX') {
                this.showGxFlag = true;
              }
              if (v.key == 'AGING_KEY') {
                this.isSlhAndWza = v.value == 0 ? false : true;
              }
              // 
              if (v.key == 'FIT_FOR_AGE_APP') {
                const setScriptSrc = el => {
                  let url = el.src.split('?')[0];
                  let paramStr = `?app=${v.value}`
                  el.src = url + paramStr;
                }
                Array.from(document.querySelectorAll('[option="slh-wza"]')).map(script => setScriptSrc(script));
              }
              sessionStorage.setItem(v.key, v.value);
            })
          } else {
            console.log(res.desc);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

  },
  created() {
    this.getConfig();
  }
}